function MinusIcon({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={`ic ${className}`} viewBox="0 0 24 24"><path fill="currentColor" d="M19 11H5a1 1 0 0 0 0 2h14a1 1 0 0 0 0-2" /></svg>
  );
}

export default MinusIcon;
